import { render, staticRenderFns } from "./LinkPdf.vue?vue&type=template&id=71134ebf"
import script from "./LinkPdf.vue?vue&type=script&lang=js"
export * from "./LinkPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports